module.exports = __webpack_public_path__ + "static/assets/img/burger-bg.8567246.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/burger-bg.png
// module id = 9l4F
// module chunks = 3